module.exports = __webpack_public_path__ + "img/newpassword.fd5dae2a.svg";